import type { ClientPortalCapabilities } from '@oneup/shared';

export interface ClientOrganization {
  clientId: string;
  displayName: string;
  role: string;
  status?: string;
  website?: string;
  logoUrl?: string;
  capabilities?: ClientPortalCapabilities;
}

export function resolveSelectedClientId(
  organizations: ClientOrganization[],
  savedClientId: string | null | undefined,
): string | null {
  if (savedClientId && organizations.some((organization) => organization.clientId === savedClientId)) {
    return savedClientId;
  }
  return organizations[0]?.clientId ?? null;
}

